import { isNullOrEmpty } from "../../helper/helper";
import { Organisation } from "../organisation/Organisation";
import { BigOpportunityModel } from "./BigOpportunityModel";
import { ContactModel } from "./ContactModel";
import { CrmFieldAgentModel } from "./CrmFieldAgentModel";

export enum current_stage {
  Qualification = "Qualification",
  Interest = "Interest",
  Engagement = "Engagement",
  Conversion = "Conversion",
  Retain_Grow = "Retain_Grow",
  Onboarded = "Onboarded",
  Failed_Onboarding = "Failed_Onboarding",
  In_Process = "In Process",
  Rejected = "Rejected",
  New_Big_Opportunity = "New_Big_Opportunity",
  Approved_Big_Opportunity = "Approved_Big_Opportunity",
  In_progress_Big_Opportunity = "In_progress_Big_Opportunity",
  Successful_Big_Opportunity = "Successful_Big_Opportunity",
  Failed_Big_Opportunity = "Failed_Big_Opportunity"
}

export const currentStageLabelMap: Record<current_stage, string> = {
  [current_stage.Qualification]: 'Qualification',
  [current_stage.Interest]: 'Interest',
  [current_stage.Engagement]: 'Engagement',
  [current_stage.Conversion]: 'Conversion',
  [current_stage.Retain_Grow]: 'Retain & Grow',
  [current_stage.Onboarded]: 'Onboarded',
  [current_stage.Failed_Onboarding]: 'Failed Onboarding',
  [current_stage.In_Process]: 'In Process',
  [current_stage.Rejected]: 'Rejected',
  [current_stage.New_Big_Opportunity]: "New_Big_Opportunity",
  [current_stage.Approved_Big_Opportunity]: "Approved_Big_Opportunity",
  [current_stage.In_progress_Big_Opportunity]: "In_progress_Big_Opportunity",
  [current_stage.Successful_Big_Opportunity]: "Successful_Big_Opportunity",
  [current_stage.Failed_Big_Opportunity]: "Failed_Big_Opportunity"

};

export class OpportunityModel {
  id: number;
  contact_id: number;
  title: string;
  description?: string;
  summary: string;
  note?: string;
  status: string;
  created_at: string;
  updated_at?: string;
  current_stage?: current_stage;
  contact?: ContactModel
  agent?: CrmFieldAgentModel
  big_opp?: BigOpportunityModel
  is_published?: boolean

  constructor(o: any) {
    this.id = o.id;
    this.contact_id = o.contact_id;
    this.title = o.title;
    this.summary = o.summary;
    this.note = o.note;
    this.status = o.status;
    this.created_at = o.created_at;
    this.updated_at = o.updated_at;
    this.current_stage = o.current_stage;
    this.contact = o.contact ? ContactModel.buildContact(o.contact) : undefined
    this.agent = o.agent ? CrmFieldAgentModel.create(o.agent) : undefined
    this.big_opp = o.big_opportunity_details ? BigOpportunityModel.build(o.big_opportunity_details) : undefined
    this.is_published = o.is_published
  }

  static buildOpportunity(o: any): OpportunityModel {
    return new OpportunityModel(o)
  }

  isRejected(): boolean {
    return !isNullOrEmpty(this.big_opp.rejection_reason);
  }

  isAccepted(): boolean {
    return this.current_stage !== current_stage.New_Big_Opportunity && !this.isRejected()
  }

  isInProcess(): boolean {
    return this.current_stage === current_stage.In_Process;
  }

  isQualified(): boolean {
    return this.current_stage === current_stage.Qualification;
  }

  isInterested(): boolean {
    return this.current_stage === current_stage.Interest;
  }

  isConverted(): boolean {
    return this.current_stage === current_stage.Conversion;
  }

  isRetained(): boolean {
    return this.current_stage === current_stage.Retain_Grow;
  }

  getStageNumber(): number | undefined {
    const order = [
      current_stage.Qualification,
      current_stage.Interest,
      current_stage.Engagement,
      current_stage.Conversion,
      current_stage.Retain_Grow,
    ];
    const idx = this.current_stage ? order.indexOf(this.current_stage) : -1;
    return idx >= 0 ? idx + 1 : undefined;
  }
}